module.exports = __webpack_public_path__ + "static/img/100W-1.0055aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/06/100W-1.png
// module id = lP9Q
// module chunks = 2